import React from 'react'

const PREVIEW_SIZES = {
  2: { cardWidth: 220, titleSize: 16, bodySize: 11, logoHeight: 44 },
  3: { cardWidth: 300, titleSize: 20, bodySize: 13, logoHeight: 56 },
}

const getPreviewSize = printWidth => PREVIEW_SIZES[printWidth] || PREVIEW_SIZES[3]

const PaperSheet = ({ printWidth, children }) => {
  const { cardWidth } = getPreviewSize(printWidth)
  return (
    <div
      style={{
        width: cardWidth,
        padding: '18px 14px',
        background: '#fff',
        border: '1px solid #d9d9d9',
        borderRadius: 4,
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
        textAlign: 'center',
      }}
    >
      {children}
    </div>
  )
}

function PersonalizacionTicketPreview({ logo, printWidth, legend, subjectQuarterlyIsr, ivaRetentionAgent }) {
  const { titleSize, bodySize, logoHeight } = getPreviewSize(printWidth)
  const bodyStyle = { fontSize: bodySize, fontWeight: 400, fontFamily: 'Arial, sans-serif', color: 'black', margin: '2px 0' }
  const boldStyle = { ...bodyStyle, fontWeight: 700 }
  const sectionStyle = { ...boldStyle, fontSize: bodySize + 1 }
  const dashed = { borderTop: '1px dashed #bbb', margin: '8px 0' }
  const rowStyle = { ...bodyStyle, display: 'flex', justifyContent: 'space-between' }

  return (
    <div style={{ display: 'flex', gap: 24, alignItems: 'flex-start', flexWrap: 'wrap' }}>
      <div>
        <div style={{ marginBottom: 10, fontWeight: 600 }}>Ticket de venta</div>
        <PaperSheet printWidth={printWidth}>
          {logo && <img src={logo} alt="" style={{ maxWidth: '100%', maxHeight: logoHeight, marginBottom: 8 }} />}
          <div style={{ ...boldStyle, fontSize: titleSize - 4 }}>Empresa de ejemplo, S.A.</div>
          <div style={bodyStyle}>NIT: 000000-0</div>
          <div style={bodyStyle}>Dirección de ejemplo</div>
          <div style={bodyStyle}>Sucursal Central</div>
          {subjectQuarterlyIsr && <div style={bodyStyle}>{'** Sujeto a pagos trimestrales ISR **'}</div>}
          {ivaRetentionAgent && <div style={bodyStyle}>{'** Agente de Retención del IVA **'}</div>}
          <div style={dashed} />
          <div style={sectionStyle}>DOCUMENTO TRIBUTARIO ELECTRÓNICO</div>
          <div style={sectionStyle}>FACTURA</div>
          <div style={{ ...bodyStyle, marginTop: 4 }}>Número de Autorización:</div>
          <div style={{ ...bodyStyle, wordBreak: 'break-all', fontSize: bodySize - 2 }}>xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</div>
          <div style={{ ...bodyStyle, fontSize: bodySize - 3, marginTop: 4 }}>Certificador: DIGIFACT SERVICIOS, S.A.</div>
          <div style={dashed} />
          <div style={{ ...rowStyle, ...boldStyle, fontSize: bodySize - 1 }}>
            <span style={{ textAlign: 'left' }}>Descripción</span>
            <span>Cant.</span>
            <span style={{ textAlign: 'right' }}>Total</span>
          </div>
          <div style={rowStyle}>
            <span style={{ textAlign: 'left' }}>Producto de ejemplo</span>
            <span>2</span>
            <span style={{ textAlign: 'right' }}>Q20.00</span>
          </div>
          <div style={dashed} />
          <div style={rowStyle}><span>Total:</span><span style={{ fontWeight: 700 }}>Q20.00</span></div>
          {legend && (
            <>
              <div style={dashed} />
              <div style={{ ...bodyStyle, fontStyle: 'italic' }}>{legend}</div>
            </>
          )}
        </PaperSheet>
      </div>
      <div>
        <div style={{ marginBottom: 10, fontWeight: 600 }}>Comanda de entrega</div>
        <PaperSheet printWidth={printWidth}>
          {logo && <img src={logo} alt="" style={{ maxWidth: '100%', maxHeight: logoHeight, marginBottom: 8 }} />}
          <div style={{ ...boldStyle, fontSize: titleSize, marginBottom: 6 }}>Comanda de entrega</div>
          <div style={boldStyle}>Empresa de ejemplo, S.A.</div>
          <div style={bodyStyle}>Sucursal Central</div>
          <div style={dashed} />
          <div style={rowStyle}><span>Vendedor:</span><span>Juan Pérez</span></div>
          <div style={rowStyle}><span>Cliente:</span><span>Consumidor Final</span></div>
          <div style={dashed} />
          <div style={{ ...rowStyle, ...boldStyle, fontSize: bodySize - 1 }}>
            <span style={{ textAlign: 'left' }}>Descripción</span>
            <span>Cant.</span>
          </div>
          <div style={rowStyle}>
            <span style={{ textAlign: 'left' }}>Producto de ejemplo</span>
            <span>2</span>
          </div>
          {legend && (
            <>
              <div style={dashed} />
              <div style={{ ...bodyStyle, fontStyle: 'italic' }}>{legend}</div>
            </>
          )}
        </PaperSheet>
      </div>
    </div>
  )
}

export default PersonalizacionTicketPreview
